(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-highlight-buttons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ph').forEach((section) => {
      const triggers = section.querySelectorAll('[data-ph-trigger]');
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';
          triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
      document.addEventListener('click', (e) => {
        if (!section.contains(e.target)) {
          triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sw-tslider]').forEach(function (slider) {
      var track = slider.querySelector('[data-sw-ttrack]');
      var slides = slider.querySelectorAll('[data-sw-tslide]');
      if (!track || slides.length === 0) return;

      var prev = slider.querySelector('[data-sw-tprev]');
      var next = slider.querySelector('[data-sw-tnext]');
      var dots = slider.querySelectorAll('[data-sw-tdot]');
      var current = 0;

      function update() {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function (d, i) {
          if (i === current) d.classList.add('is-active');
          else d.classList.remove('is-active');
        });
      }

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        update();
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(idx)) goTo(idx);
        });
      });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
